import React, { useState, useEffect } from 'react';
import Footer from '../components/layout/Footer';
import '../App.css';
import { Link } from 'react-router-dom';
import { getAllNotifications } from '../services/api';

const BASE_API = process.env.REACT_APP_API_URL.replace(/\/api\/?$/, '');

const News = () => {
  const articlesPerPage = 2;
  const [currentPage, setCurrentPage] = useState(1);
  const [allArticles, setAllArticles] = useState([]);
  const [phuNotifications, setPhuNotifications] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);

    getAllNotifications()
      .then((res) => {
        const notifications = res.data || [];

        const phu = notifications.filter((item) => item.type === 'Phụ');
        const chinh = notifications.filter((item) => item.type === 'Chính');

        const all = [...chinh, ...phu].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

        setAllArticles(chinh);
        setPhuNotifications(phu);
        setAllNotifications(all); // tạo thêm 1 state chứa tất cả thông báo
      })
      .catch((err) => {
        console.error('Lỗi khi lấy thông báo:', err);
      });
  }, []);
  const [allNotifications, setAllNotifications] = useState([]);
  const totalPages = Math.ceil(allArticles.length / articlesPerPage);
  const startIdx = (currentPage - 1) * articlesPerPage;
  const currentArticles = allArticles.slice(startIdx, startIdx + articlesPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <div className="pt-16 min-h-screen bg-gray-50">
      <section className="bg-gradient-to-r from-primary-600 to-primary-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6 text-white">Bản Tin Nam Kiến Văn</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Cập nhật nhanh những thông báo quan trọng, sự kiện mới và tin tức học tập dành riêng cho học sinh và phụ huynh
          </p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          <div className="lg:col-span-1">
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden sticky top-24">
              <div className="p-6">
                <h3 className="text-xl font-bold text-blue-600 mb-4 border-l-4 border-blue-600 pl-3">
                  Tất cả thông báo
                </h3>

                <div className="relative h-80 overflow-hidden rounded-xl border border-blue-100 bg-blue-50 p-4">
                  <div className="absolute animate-marquee-vertical space-y-3 w-full">
                    {allNotifications.map((item) => (
                      <p key={item.id} className="text-sm text-gray-800 leading-relaxed">
                        {item.type === 'Phụ' ? '📌' : '📣'} {item.title}
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="flex justify-between items-center mb-8">
              <h2 className="text-2xl font-bold text-gray-900">Tin tức mới nhất 📣</h2>
              <button className="text-blue-600 hover:text-blue-700 font-medium">
                Xem thêm
              </button>
            </div>

            <div className="space-y-8">
              {currentArticles.map((article) => (
                <article
                  key={article.id}
                  className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
                >
                  <div className="md:flex">
                    <div className="md:w-1/3">
                      <img
                        src={`${BASE_API}/${(article.thumbnail_url || 'uploads/thumbnails/default.jpg').replace(/^\/+/, '')}`}

                        alt="Thumbnail"
                        className="w-full h-64 object-cover"
                      />
                    </div>

                    <div className="md:w-2/3 p-6">
                      <div className="flex items-center mb-3">
                        <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-xs font-medium mr-3">
                          {article.category || 'Thông báo'}
                        </span>
                        <span className="text-gray-500 text-sm">
                          {new Date(article.created_at).toLocaleDateString('vi-VN')}
                        </span>
                      </div>

                      <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                        {article.title}
                      </h3>

                      <p className="text-gray-600 mb-4 line-clamp-3">{article.message}</p>

                      {article.file_url && (
                        <a
                          href={`${BASE_API}/${article.file_url.replace(/^\/+/, '')}`}
                          {...(article.file_url.toLowerCase().endsWith('.pdf')
                            ? { target: '_blank', rel: 'noopener noreferrer' }
                            : { download: true })}
                          className="inline-block mb-3 text-blue-600 hover:text-blue-700 font-medium text-sm me-3"
                        >
                          {article.file_url.toLowerCase().endsWith('.pdf') ? 'Xem tài liệu' : 'Tải xuống tài liệu'}
                        </a>
                      )}

                      <Link to={`/tin-tuc/${article.id}`} className="text-blue-600 hover:text-blue-700 font-medium text-sm">
                        Đọc thêm
                      </Link>
                    </div>
                  </div>
                </article>
              ))}
            </div>

            <div className="flex justify-center mt-10 space-x-2">
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  onClick={() => handlePageChange(index + 1)}
                  className={`px-4 py-2 border rounded-lg ${currentPage === index + 1
                    ? 'bg-blue-600 text-white'
                    : 'bg-white text-blue-600 border-blue-600 hover:bg-blue-100'
                    }`}
                >
                  {index + 1}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      <section className="bg-white py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h3 className="text-3xl font-bold text-gray-900 mb-4">Thông báo phụ 📌</h3>
          <p className="text-lg text-gray-600 mb-8">
            Những cập nhật nhỏ, tin nhanh và nhắc nhở dành cho học sinh - sinh viên
          </p>

          <div className="text-left max-w-2xl mx-auto space-y-4">
            {phuNotifications.length > 0 ? (
              phuNotifications.map((item) => (
                <div
                  key={item.id}
                  className="p-4 bg-blue-50 border border-blue-200 rounded-lg text-sm text-blue-800"
                >
                  <strong className="block font-semibold mb-1">{item.title}</strong>
                  <p className="mb-2">{item.message}</p>

                  {item.file_url && (
                    <a
                      href={`${BASE_API}/${item.file_url.replace(/^\/+/, '')}`}
                      {...(item.file_url.toLowerCase().endsWith('.pdf')
                        ? { target: '_blank', rel: 'noopener noreferrer' }
                        : { download: true })}
                      className="inline-block text-blue-600 hover:text-blue-700 font-medium text-sm me-3"
                    >
                      {item.file_url.toLowerCase().endsWith('.pdf') ? 'Xem tài liệu' : 'Tải xuống tài liệu'}
                    </a>
                  )}

                  
                </div>
              ))
            ) : (
              <p className="text-gray-500 text-sm">Không có thông báo phụ nào.</p>
            )}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default News;
